import {
    SET_VOLUUM_DAILY,
    CLEAR_VOLUUM_DAILY,
    GET_VOLUUM_DAILY_SUCCESS,
    GET_VOLUUM_DAILY_FAILED,
} from '../../actions/type';

const initialState = { data: null, status: 'idle' };

export default function voluumDailyReducer(state = initialState, action) {
    const { type, data } = action;

    switch (type) {
        case SET_VOLUUM_DAILY:
            return {
                ...state,
                data,
            }
        case CLEAR_VOLUUM_DAILY:
            return {
                ...state,
                data: null,
            }
        case GET_VOLUUM_DAILY_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_VOLUUM_DAILY_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}